/*
 * スクロールを遅くするセクション
 *
 * `data-iroiro-slow="0.3"` を付けた要素が、その割合の速さで上へ動く。
 * 0.3 なら、まわりが100px動くあいだに30pxしか動かない。
 * 結果として後ろのセクションが追いついてきて、その上を覆っていく。
 *
 * 【やっていること】
 * 通常の流れでは要素はスクロール量ぶん上へ動く。
 * そこへ下向きの transform を足して、差し引きの移動量を減らしている。
 *
 *   ずらす量 = 通過した量 × (1 − 速さ)
 *
 * 下向きにずらすので、空きができるのは要素の「上」側になる。
 * そこはすでに画面の外へ抜けた場所なので見えない。
 * 下側にはみ出すぶんは、次のセクションが覆うので見えない
 * （重ね順と地色は assets/iroiro-mainvisual.css で指定している）。
 *
 * 【固定（position: sticky）にしなかった理由】
 * sticky は完全に止まってしまい、少しずつ動く見せ方にはならない。
 * また止まっているあいだ要素の位置が変わらないため、
 * どれだけ通過したかを要素自身から測れなくなる。
 */
(function () {
  'use strict';

  var SELECTOR = '[data-iroiro-slow]';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /*
   * スクロール連動アニメーションが使えるブラウザでは、
   * assets/iroiro-base.css がCSSだけで同じ動きを作る。
   * そちらのほうが遅れが出ないので、ここでは何もしない。
   */
  if (window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()')) return;

  var items = [];
  var queued = false;

  function measure() {
    /*
     * 位置は transform を外した状態で測る。
     * ずらしたままだと、測るたびに基準が動いてしまう。
     */
    items.forEach(function (item) {
      item.el.style.transform = '';
    });

    var scrollY = window.pageYOffset;

    items.forEach(function (item) {
      item.top = item.el.getBoundingClientRect().top + scrollY;
      item.max = item.el.offsetHeight * 0.8;
    });
  }

  function apply() {
    var scrollY = window.pageYOffset;

    items.forEach(function (item) {
      var passed = scrollY - item.top;
      if (passed <= 0) {
        item.el.style.transform = '';
        return;
      }
      var shift = Math.min(passed * (1 - item.speed), item.max);
      item.el.style.transform = 'translate3d(0, ' + shift + 'px, 0)';
    });
  }

  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      apply();
    });
  }

  function onResize() {
    measure();
    apply();
  }

  function init() {
    items = Array.prototype.map.call(document.querySelectorAll(SELECTOR), function (el) {
      var speed = parseFloat(el.dataset.iroiroSlow);
      /*
       * will-change は付けない。
       *
       * 付けると要素が合成用のレイヤーに載りっぱなしになる。
       * スマホのブラウザはそのレイヤーをスクロール中だけ粗く描いて
       * あとから描き直すことがあり、一瞬拡大されたように見える。
       * transform を当てているあいだは自動でレイヤーに載るので、
       * 前もって宣言する必要はない。
       */
      return { el: el, speed: isNaN(speed) ? 0.3 : speed, top: 0, max: 0 };
    });

    if (!items.length) return;

    measure();
    apply();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    // 画像の読み込みで位置が変わるため、読み込み完了後に測り直す
    window.addEventListener('load', onResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
